import { restfulClient, actionClient } from '@/api'
import { cloneDeep } from 'lodash'
import { formatParams } from '@/helpers'
import config from '@/config'
import store from '@/store'

// 奖品列表
export const prizeOptionApi = {
  path: '/user-dispatch-prize/options',
  async paginator(query = {}) {
    return await restfulClient.getCollection(this.path, { query })
  }
}

// 有奖调查
export const awardListApi = {
  path: '/activity/questionnaire/activities',
  async paginator(query = {}) {
    return await restfulClient.getCollection(this.path, formatParams(query))
  },
  async create(query = {}) {
    return await restfulClient.create(this.path, query)
  },
  async remove(id) {
    return await restfulClient.remove(this.path, id)
  },
  async get(id) {
    return await restfulClient.getDocument(this.path, id, ['rules'])
  },
  async replace(query = {}) {
    return await restfulClient.put(this.path, query.id, query)
  }
}
// 参与名单
export const questionnaireListApi = {
  path: '/activity/questionnaire/records',
  async paginator(query) {
    return await restfulClient.getCollection(this.path, {...query,sorts:{id:'asc'}})
  },
  async get(id) {
    return await restfulClient.getDocument(this.path, id,['questionnaireActivity'])
  },
  async update(id, query = {}) {
    return await restfulClient.update(this.path, id, query)
  }
}

